module.exports = __webpack_public_path__ + "static/media/breads1.a6ec347e.png";